import React from 'react';
import { useMediaQuery } from '@mui/material';
import Info from './Info';
import { imageUrl } from '../../utils';

interface JourneyStep {
  number: number;
  title: string;
  duration?: string;
  description: string;
  items: string[];
  icon?: string;
  alt?: string;
}

interface OurJourneyProps {
  title?: string;
  steps: JourneyStep[];
  containerClass?: string;
}

const OurJourney = ({ 
  title = 'Our Journey', 
  steps, 
  containerClass 
}: OurJourneyProps) => {
  const isLessThan1280 = useMediaQuery('(max-width: 1280px)');
  const isLessThan640 = useMediaQuery('(max-width: 640px)');

  return (
    <section className={`bg-[#F5CA09] py-20 ${containerClass || ''}`}>
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl font-bold text-black text-center mb-16">
            {title}
          </h2>
          <div className="space-y-8">
            {steps.map((step, index) => (
              <div key={step.number} className="relative">
                {/* Vertical line (hidden on last step) */}
                {index < steps.length - 1 && (
                  <div className="absolute left-6 top-16 bottom-0 w-0.5 bg-gradient-to-b from-[#FA832E] to-transparent" style={{ zIndex: 1 }}></div>
                )}
                
                <div className="flex gap-8">
                  {/* Number circle */}
                  <div className="flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center text-white font-bold relative z-[1]" style={{ backgroundColor: '#FA832E' }}>
                    {step.number}
                  </div>
                  
                  {/* Content card */}
                  <div className="flex-1 pb-8">
                    <div className="bg-white rounded-2xl p-8 border border-gray-200 hover:border-yellow/50 transition-colors">
                      {/* Title and duration */}
                      <div className="flex items-center justify-between gap-4 mb-2">
                        <div className="flex items-center gap-4">
                          <h3 className="text-2xl font-bold text-black m-0 leading-tight">{step.title}</h3>
                          {step.duration && (
                            <span className="text-sm" style={{ color: '#728F8B' }}>{step.duration}</span>
                          )}
                        </div>
                        {/* Icon on the right */}
                        {step.icon && (
                          <div className="flex-shrink-0 flex items-center justify-center" style={{ width: 52, height: 52 }}>
                            <img 
                              loading="lazy" 
                              src={imageUrl(step.icon)} 
                              alt={step.alt || step.title}
                              className="w-full h-full object-contain"
                              style={{ filter: 'brightness(0) saturate(100%) invert(68%) sepia(1%) saturate(0%) hue-rotate(314deg) brightness(96%) contrast(89%)' }}
                            />
                          </div>
                        )}
                      </div>
                      {/* Description */}
                      <p className="mb-4" style={{ color: '#728F8B' }}>
                        {step.description}
                      </p>
                      {/* Bullet points */}
                      <div className="space-y-1.5">
                        {step.items.map((item, itemIndex) => (
                          <div key={itemIndex} className="flex items-center gap-2">
                            <div className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: '#FA832E' }}></div>
                            <span className="text-sm text-black">{item}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurJourney;

